module.exports = new __parcel__URL__("train_1_inactive.b18b3327.png").toString();